<aside class="sidebar-shell border d-flex flex-column position-relative overflow-hidden">

  <div class="sidebar-static-top">
    <!-- BRAND HEADER -->
    <div class="sidebar-header">
      <SidebarBrand
        :logo="logo"
        :title="brand_title"
        :subtitle="brand_subtitle"
      />

      <!-- MOBILE CLOSE ACTION -->
      <slot name="sidebar-header-actions"></slot>
    </div>

    <hr class="border-bottom border-dark border mt-0">

    <!-- CONTEXT BLOCK -->
    <slot name="context"></slot>

    <hr class="border-bottom border-dark border mb-0">
  </div>

  <!-- MENU BLOCK -->
  <div class="sidebar-menu-scroll">
    <slot name="menu"></slot>
  </div>

  <!-- FOOTER (USER INFO) -->
  <SidebarUserFooter
    :initials="initials"
    :full_name="full_name"
  />

</aside>
